var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-commander.50ebcd5e.png","uri@3x": __webpack_public_path__ + "icon-commander.5f5ac2bf.png","uri@2x": __webpack_public_path__ + "icon-commander.b76f9543.png",
    width: 38,
    height: 27
});